export default {
  analysis: (state) => state.analysis,
  activityProgress: (state) => state.activityProgress,
  bodyfatProgress: (state) => state.bodyfatProgress,
  bodyweightProgress: (state) => state.bodyweightProgress,
  challengeProgress: (state) => state.challengeProgress,
  membershipProgress: (state) => state.membershipProgress,
  nutritionProgress: (state) => state.nutritionProgress,
  dashboardProgress: (state) => state.dashboardProgress,
  members: (state) => state.members,
  isAllChecked: (state) => state.isAllChecked,
}
